import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Alert, AlertTitle, Box } from '@mui/material';

interface Props {
  enabled: boolean;
  loading: boolean;
  count: number;
  error?: string;
  text?: string;
}

const OptionsCountAlert: FC<Props> = ({ enabled, loading, count, error, text = 'suggest' }) => {
  const { t } = useTranslation();
  return (
    <>
      {!enabled && (
        <Alert severity="warning">
          <AlertTitle>{t('hiring-dashboard-candidates:candidates.optionsCountAlert.suggestedTimesOff')}</AlertTitle>
          {t('hiring-dashboard-candidates:candidates.optionsCountAlert.enableSuggestions')}
        </Alert>
      )}
      {!error && enabled && (
        <Box mt={1}>
          {!loading && Boolean(count) && (
            <Alert severity="success">
              <AlertTitle>
                {t('hiring-dashboard-candidates:candidates.optionsCountAlert.foundTimes', { count, text })}
              </AlertTitle>
            </Alert>
          )}
          {!loading && !count && (
            <Alert severity="error">
              <AlertTitle>
                {t('hiring-dashboard-candidates:candidates.optionsCountAlert.noTimesFound', { text })}
              </AlertTitle>
              {t('hiring-dashboard-candidates:candidates.optionsCountAlert.noTimesDescription')}
            </Alert>
          )}
        </Box>
      )}
      {error && enabled && (
        <Box mt={1}>
          <Alert severity="error">
            <AlertTitle>{error}</AlertTitle>
          </Alert>
        </Box>
      )}
    </>
  );
};

export default OptionsCountAlert;
